var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPerformance = function SvgPerformance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "performance_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".performance_svg__st3{fill:#ed4300}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "performance_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "performance_svg__SVGID_00000141417775543765324190000014071812468421069955_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#performance_svg__SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M40.001 80c22.093 0 40-17.909 40-40 0-22.093-17.907-40.001-40-40.001S.001 17.908.001 40s17.907 40 40 40"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#260046",
    d: "M58.562 60.415H21.438a1.985 1.985 0 01-1.986-1.986V23.337a1.986 1.986 0 013.972 0v33.105h35.138a1.986 1.986 0 110 3.973"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.033 41.748h6.37v10.609h-6.37z",
    className: "performance_svg__st3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.748 29.736h6.367v22.621h-6.367z",
    className: "performance_svg__st3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.464 32.98h6.367v19.377h-6.367z",
    className: "performance_svg__st3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.179 22.582h6.367v29.775h-6.367z",
    className: "performance_svg__st3"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPerformance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/performance.26f26b1d7dace7e3ae8640f3ed78295f.svg";